import styled from 'styled-components';

export const CDIContainer = styled.form`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.white};
  box-shadow: ${(props) => props.theme['shadow-2']};
  padding: 2rem;
  border-radius: 8px;
  gap: 1rem;
  width: 100%;
  
  height: 200px;

  label {
    margin: 0;
    color: ${props => props.theme['gray-800']};
    font-size: .875rem;
    font-weight: 500;
  }
`;
